import { render, staticRenderFns } from "./AddServiceFeeDialog.vue?vue&type=template&id=17f3c241&scoped=true"
import script from "./AddServiceFeeDialog.vue?vue&type=script&lang=js"
export * from "./AddServiceFeeDialog.vue?vue&type=script&lang=js"
import style0 from "./AddServiceFeeDialog.vue?vue&type=style&index=0&id=17f3c241&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f3c241",
  null
  
)

export default component.exports